import React from 'react';
import { CreditCard, Loader2 } from 'lucide-react';
import type { CardReturnState } from './useCardReturn';
import { paymentWords } from './paymentWords';
import type { CheckoutLanguage } from '../components/checkoutLabels';

// What the thank-you page says about a card payment it is still settling: that it is being checked, that it did
// not go through (with the way to pay again), or that it could not be checked at all.

type CardPaymentPendingProps = { state: Exclude<CardReturnState, { stage: 'none' }>; language: CheckoutLanguage | null | undefined };

// Draws a card payment that is not confirmed yet, in the store's language.
export const CardPaymentPending: React.FC<CardPaymentPendingProps> = ({ state, language }) => {
  const words = paymentWords(language);
  if (state.stage === 'checking') return <div className="xe-order-empty" role="status"><Loader2 className="animate-spin" size={28} aria-hidden="true" /><p>{words.checking}</p></div>;
  if (state.stage === 'failed') return <div className="xe-order-empty" role="alert"><p>{words.failed}</p></div>;
  return (
    <div className="xe-order-empty" role="status">
      <h1 className="xe-order-card-title">{words.unpaidTitle}</h1>
      <p>{words.unpaidText.replace('{number}', state.orderNumber)}</p>
      <button type="button" className="btn-submit-order" onClick={state.retry} disabled={state.retrying}>
        {state.retrying ? <Loader2 className="animate-spin" size={20} aria-hidden="true" /> : <CreditCard size={20} aria-hidden="true" />}
        <span>{words.payAgain}</span>
      </button>
    </div>
  );
};
